export default __webpack_public_path__ + "static/media/logo_primary.eb3ad13b.png";